import { Select, Spin } from 'antd'
import { useRef, useState } from 'react'

export function SL_AutoCompleteSelect({
    fetchOptions,
    debounceTimeout = 250,
    charactersLimitToFetch = 3,
    value,
    onChange,
    placeholder,
    ...props
}) {
    const [fetching, setFetching] = useState(false)
    const [options, setOptions] = useState([])
    const fetchRef = useRef(0)

    function cleanOptions() {
        if (options.length != 0) {
            setOptions([])
        }
    }

    const onSearch = value => {
        cleanOptions()
        if (value.length < charactersLimitToFetch) {
            fetchRef.current = 0
            return
        }

        setFetching(true)

        fetchRef.current += 1
        const fetchId = fetchRef.current

        setTimeout(async () => {
            try {
                const newOptions = await fetchOptions(value)
                if (fetchId !== fetchRef.current) {
                    return
                }

                setOptions(newOptions)
            } finally {
                setFetching(false)
            }
        }, debounceTimeout)
    }

    return (
        <Select
            labelInValue
            filterOption={false}
            onSearch={onSearch}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            options={options}
            onBlur={() => {
                cleanOptions()
            }}
            mode="multiple"
            style={{
                width: '200px',
            }}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            {...props}
        />
    )
}
